module.exports = __webpack_public_path__ + "static/img/shuzhihua(1).37b10d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/shuzhihua(1).png
// module id = 5wtz
// module chunks = 36